export const TOOLTIP_CONTENT = {
  OFFERS_PAGE: `Con Powerpay podrás dividir tus compras en plazos de 3 \ncuotas sin intereses (TEA 0.00% y TCEA 0.00%). \nEn 6 y 12 cuotas cobramos una comisión que varía en función \na tu compra: desde S/6.66 hasta S/ 1,225.80 (TEA 0.00% y \nTCEA variable de hasta 66%). \nEsta comisión la cobraremos de forma fraccionada en cada \nuna de las cuotas en partes iguales.`,
  SUMMARY_COMPONENT: `Con Powerpay podrás dividir tus compras en plazos de 3 cuotas sin intereses (TEA 0.00% y TCEA 0.00%). \nEn 6 y 12 cuotas cobramos una comisión que varía en función a tu compra: desde S/6.66 hasta S/ 1,225.80 (TEA 0.00% y TCEA variable de hasta 66%). \nEsta comisión la cobraremos de forma fraccionada en cada una de las cuotas en partes iguales.`,
};

export const TOOLTIP_DELAY = {
  ONE_SECOND: 1000,
  TWO_SECONDS: 2000,
  THREE_SECONDS: 3000,
  FOUR_SECONDS: 4000,
  FIVE_SECONDS: 5000,
};
